module.exports = __webpack_public_path__ + "img/img03.e431dd97.jpg";